// Five-dot tier indicator under each archetype name.

import { cn } from '@aod/ui/lib/utils';
import type { Archetype } from './archetypes.js';

interface DotsRowProps {
  readonly archetypeId: Archetype;
  readonly points: number;
  readonly accentColor: string;
}

// Hard-coded tier slots — the array is fixed-length (5) and never reorders, so
// a hand-rolled list with stable string keys keeps Biome's no-array-index rule
// happy without a per-line disable comment.
const TIER_SLOTS: ReadonlyArray<readonly [number, string]> = [
  [0, 't0'],
  [1, 't1'],
  [2, 't2'],
  [3, 't3'],
  [4, 't4'],
];

export function DotsRow({ archetypeId, points, accentColor }: DotsRowProps) {
  return (
    <div className="flex gap-1" aria-hidden>
      {TIER_SLOTS.map(([slot, slug]) => (
        <span
          key={`${archetypeId}-${slug}`}
          className={cn('h-1.5 w-1.5 rounded-full transition-colors', slot >= points && 'bg-muted')}
          style={slot < points ? { background: accentColor } : undefined}
        />
      ))}
    </div>
  );
}
